export const sanitizeBillId = (billId?: string): string | undefined => {
    if (billId) {
        return billId.replace(/\D/g, '').trim();
    }

    return undefined;
};
